module.exports = __webpack_public_path__ + "static/media/buttonsounds05.683aef9e.wav";